module.exports = __webpack_public_path__ + "img/三门控制器 (9).64ecebe5.jpg";